'use client';

import { datadogRum } from '@datadog/browser-rum';
import { PropsWithChildren } from 'react';

const applicationId = process.env.NEXT_PUBLIC_APPLICATION_ID;
const clientToken = process.env.NEXT_PUBLIC_CLIENT_TOKEN;
const env = process.env.NEXT_PUBLIC_ENV;

if (applicationId && clientToken && env) {
  datadogRum.init({
    applicationId,
    clientToken,
    site: 'datadoghq.com',
    service: 'gptkillerjp',
    env,
    sessionSampleRate: 5,
    sessionReplaySampleRate: 0,
    trackUserInteractions: true,
    trackResources: true,
    trackLongTasks: true,
    defaultPrivacyLevel: 'allow',
  });
} else {
  console.warn('Datadog RUM: Missing environment variables. RUM tracking will be disabled.');
}
export const RUM = ({ children }: PropsWithChildren) => {
  return <>{children}</>;
};
